<template>
  <vue-final-modal v-slot="{ close }" classes="mega-alert-container" content-class="mega-alert-content"
    :esc-to-close="true" :focus-trap="true" @opened="onOpened" @before-close="respond('no')">
      <div class="art" :class="level"><!-- agreeart warningart -->
        <span class="img" aria-hidden="true"></span>
        <p v-html="$t(code)"></p>
        <div class="btn">
          <template v-if="type == 'confirm'">
            <button type="button" class="yes" @click="respond('yes', close)">{{$t('front.button.yes')}}</button>
            <button type="button" class="no" @click="respond('no', close)">{{$t('front.button.no')}}</button>
          </template>

          <template v-if="type == 'check'">
            <button type="button" class="yes" @click="respond('ok', close)">{{$t('front.button.confirm')}}</button>
          </template>
        </div>
        <button type="button" class="closeart" aria-label="닫기" @click="respond('no', close)"><img src="@/assets/img/icon_x.svg" alt="" /></button>
      </div>
  </vue-final-modal>

</template>

<script>

export default {
  name: 'Alert',
  emits: ['confirm', 'check'],
  props: {
    code: {
      type: String
    },
    type: {
      type: String,
      default: 'check'
    },
    level: {
      type: String,
      default: 'warningart'
    }
  },
  data () {
    return {
      settled: false
    }
  },
  methods: {
    onOpened ({ ref }) {
      ref.vfmContainer.value.setAttribute('aria-label', this.$t('front.button.confirm'))
    },
    respond (result, close = () => {}) {
      if (this.settled) return
      this.settled = true
      this.$emit(this.type, result, close)
    }
  }
}
</script>

<style scoped>
:deep(.mega-alert-container) { display: flex; align-items: center; justify-content: center; padding: 20px; }
:deep(.mega-alert-content) { width: 440px; max-width: 100%; }
.art { position: relative; box-sizing: border-box; width: 100%; max-height: calc(100dvh - 40px); overflow-y: auto; padding: 36px 28px 28px; border: 1px solid #92e4d1; border-right-color: #b28af0; border-bottom-color: #b28af0; border-radius: 12px; background: rgba(35, 39, 43, .98); box-shadow: 0 18px 60px #0008; text-align: center; color: #f3f5f8; }
.img { display: block; width: 48px; height: 48px; margin: 0 auto 20px; background: url('~@/assets/img/warningart.svg') center / contain no-repeat; }
.agreeart .img { background-image: url('~@/assets/img/agreeart_green.svg'); }
.art p { margin: 0; font-size: 16px; line-height: 1.65; overflow-wrap: anywhere; }
.btn { display: flex; justify-content: center; gap: 12px; margin-top: 26px; }
button { cursor: pointer; font: inherit; }
.yes, .no { flex: 1; max-width: 184px; min-height: 44px; padding: 10px 16px; border: 1px solid transparent; border-radius: 8px; font-size: 15px; font-weight: 700; }
.yes { color: #25283d; background: linear-gradient(135deg, #94e0ee, #ac7def); }
.no { color: #f3f5f8; border-color: #737b85; background: #424950; }
.yes:hover, .no:hover { filter: brightness(1.1); }
button:focus-visible { outline: 2px solid #a9f4e0; outline-offset: 3px; }
.closeart { position: absolute; top: 4px; right: 4px; display: grid; place-items: center; width: 44px; height: 44px; padding: 10px; border: 0; background: transparent; border-radius: 8px; }
.closeart img { width: 24px; height: 24px; }
@media (max-width: 480px) {
  :deep(.mega-alert-container) { padding: 16px; }
  .art { max-height: calc(100dvh - 32px); padding: 32px 20px 24px; }
  .art p { font-size: 15px; }
}
</style>
